import script from "./SystemAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemAlert.vue?vue&type=script&setup=true&lang=js"

import "./SystemAlert.vue?vue&type=style&index=0&id=a98940d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98940d6"]])

export default __exports__